<!-- src/components/WangEditor/index.vue -->
<template>
  <div style="z-index: 99; border: 1px solid #ccc;width: 100%;">
    <!-- 工具栏 -->
    <Toolbar
      :editor="editorRef"
      mode="simple"
      :default-config="toolbarConfig"
      style="border-bottom: 1px solid #ccc;width: 100%;"
    />
    <!-- 编辑器 -->
    <Editor
      v-model="modelValue"
      style="height: 90%;width: 100%;"
      :default-config="editorConfig"
      mode="simple"
       @onChange="handleChange"
      @on-created="handleCreated"
    />
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, shallowRef, reactive, toRefs,inject } from 'vue';
import "@wangeditor-next/editor/dist/css/style.css";
import { Toolbar, Editor } from "@wangeditor-next/editor-for-vue";
import { setshelvesFilterAPI } from '@/apis/pay'

import axios from 'axios'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n();
    // i18nChangeLanguage('en'); // 切换为英文
const props=defineProps({
  modelValue: {
    type: String,
  },
});
const emits = defineEmits(['contentChangita','contentChangde','contentChangpcf','contentChangen','contentChangzn','contentChangesp','contentChangpcp','contentChangned','contentChangpl']);
// 双向绑定
const modelValue=ref();
onMounted(() => {
      setTimeout(() => {
        const editors = editorRef.value;
        modelValue.value=props.modelValue
        editors.insertText(props.modelValue)
      }, 1500);
    });

const handleChange=(editor)=>{
  emits('contentChangzn',editor.getHtml())
  emits('contentChangen',editor.getHtml())
  emits('contentChangesp',editor.getHtml())
  emits('contentChangpcp',editor.getHtml())
  emits('contentChangpcf',editor.getHtml())
  emits('contentChangde',editor.getHtml())
  emits('contentChangita',editor.getHtml())
  emits('contentChangned',editor.getHtml())
  emits('contentChangpl',editor.getHtml())
  
}
// 编辑器实例，必须用 shallowRef，重要！
const editorRef = shallowRef();

// 工具栏配置
const toolbarConfig = ref({});

// 编辑器配置
const editorConfig = ref({
  placeholder: "请输入内容...",
  MENU_CONF: {
      uploadImage: {
            
            // 自定义图片上传
            async customUpload(file, insertFn) {
      try {
          // 1. 获取文件扩展名
          console.log(file);
          console.log(file.type);
          // const fileExt = file.File.name.split('.').pop()
          if (!["image/png", "image/jpeg"].includes(file.type)) {
              console.error(t('setup498'));
              return;
          }
          let fileExt =''
          if(file.type=='image/jpeg'){
              fileExt='jpg';
          }else{
              fileExt='png';
          }
          // 2. 调用后端接口获取预签名URL
          const { data: presignedData } = await setshelvesFilterAPI({
              fileExtension: fileExt,
              bucketName: 'product-content'
          })
  
          // 3. 准备表单数据
          const formData = new FormData()
          // 添加后端返回的所有表单字段
          Object.entries(presignedData.formData).forEach(([key, value]) => {
              formData.append(key, value)
          })
          console.log(presignedData.formData)
          // 添加文件
          formData.append('file', file)
  
          // // 4. 执行上传
          const response = await axios.post(presignedData.url, formData, {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
          })
  
          // // 5. 上传成功
          if (response.status === 204) {
              console.log(response)
              ElMessage.success(t('number20'))
              // 构建文件访问URL
              const fileUrl = `${presignedData.url}${presignedData.formData.key}`
              console.log(fileUrl)
              // 可以在这里处理上传成功后的逻辑，比如将fileUrl保存到表单中
              // from.coverUrl = fileUrl
              // from.multiSkuData[index].values[indexs].img=fileUrl
              console.log(fileUrl)
              insertFn(fileUrl); 
          }
      } catch (error) {
          ElMessage.error( error.message)
          throw error
      }
  
            }
          }
      },
  },
);

// 记录 editor 实例，重要！
const handleCreated = (editor) => {
  editorRef.value = editor;
 
};

// 组件销毁时，也及时销毁编辑器，重要！
onBeforeUnmount(() => {
  const editor = editorRef.value;
  if (editor == null) return;
  editor.destroy();
});
const Reseteditor=(data)=>{
  // setTimeout(() => {
  const editors = editorRef.value;
        modelValue.value=data
        editors.insertText(data)
      // }, );
}
// 第二部：暴露方法
defineExpose({
		Reseteditor
	})
</script>
